import jwtDecode from "jwt-decode";

export const useJwtCookie = (key: string = "token") => {
  const cookies = (window as any).document.cookie.split("; ").reduce((acc, cur) => {
    const [k, v] = cur.split("=");
    if (!k) return acc;
    return {
      ...acc,
      [k.trim()]: v?.trim(),
    };
  }, {});
  const token = cookies[key];

  let result = null;
  if (token) {
    try {
      result = jwtDecode(token);
      if (result.exp * 1000 < Date.now()) {
        result = null;
      }
    } catch (e) {
      console.warn(`Error decoding MFA JWT: ${e.message}`);
      result = null;
    }
  }
  return {
    data: result,
    token,
  };
};
